/**
 * Coerce a value to a finite number. Falls back when missing or unparseable.
 */
export const parseFiniteNumber = (value: unknown, fallback = 0): number => {
  const parsed = typeof value === 'number' ? value : Number(value);

  return Number.isFinite(parsed) ? parsed : fallback;
};

/**
 * Format a number with a fixed number of decimal places.
 */
export const formatFixedDecimal = (value: number, fractionDigits = 2): string =>
  value.toFixed(fractionDigits);
